var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPotentialLeadsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58335 11.5794C5.58335 10.682 6.31089 9.95443 7.20835 9.95443C8.10582 9.95443 8.83335 10.682 8.83335 11.5794C8.83335 12.4769 8.10582 13.2044 7.20835 13.2044C6.31089 13.2044 5.58335 12.4769 5.58335 11.5794Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7917 13.2044C15.6892 13.2044 16.4167 12.4769 16.4167 11.5794C16.4167 10.682 15.6892 9.95443 14.7917 9.95443C13.8942 9.95443 13.1667 10.682 13.1667 11.5794C13.1667 12.4769 13.8942 13.2044 14.7917 13.2044Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166687 11.5794C0.166687 5.59634 5.01694 0.746094 11 0.746094C16.9831 0.746094 21.8334 5.59634 21.8334 11.5794C21.8334 17.5625 16.9831 22.4128 11 22.4128C5.01694 22.4128 0.166687 17.5625 0.166687 11.5794ZM10.4584 11.5794C10.4584 12.1714 10.3001 12.7264 10.0236 13.2044H11.9765C11.7 12.7264 11.5417 12.1714 11.5417 11.5794C11.5417 9.7845 12.9968 8.32943 14.7917 8.32943C16.5866 8.32943 18.0417 9.7845 18.0417 11.5794C18.0417 13.3744 16.5866 14.8294 14.7917 14.8294H7.20835C5.41343 14.8294 3.95835 13.3744 3.95835 11.5794C3.95835 9.7845 5.41343 8.32943 7.20835 8.32943C9.00328 8.32943 10.4584 9.7845 10.4584 11.5794Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialLeadsActive);
export default __webpack_public_path__ + "static/media/potential-leads-active.b6152bf678b1e57fa0308169a0f91599.svg";
export { ForwardRef as ReactComponent };